import {createAsyncThunk} from '@reduxjs/toolkit';
import {integrationsApi} from 'api';
import {IBindBaseEnumEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from '../config';

export const fetchIntegrationTypesThunk: any = createAsyncThunk<IBindBaseEnumEntity[]>(
  `${prefix} fetchIntegrationTypes`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await integrationsApi.getIntegrationTypes();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch integration types. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
